// Shared by ajax form error handlers. Kept free of jQuery so it can be unit-tested
// with plain Node (see test/javascript/ajax_form_errors_test.mjs).
export function ajaxFormErrors(xhr) {
  const errors = xhr && xhr.responseJSON;
  if (!errors) return null;
  return errors;
}
